{
  "replaceMessage": "Pašalinkite failą, kad pakeistumėte"
}
